import { chakra } from "@chakra-ui/react";

import { VBabyColors } from "../../colors";

export const Container = chakra("div", {
  base: {
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
    justifyItems: "center",
    width: "100%",
    minHeight: "100dvh",
    background: "vbaby.canvas",
  },
});

export const Header = chakra("header", {
  base: { width: "100%", padding: "8px 0" },
});

export const ContainerLogo = chakra("div", {
  base: {
    width: "100%",
    height: "54px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center",
  },
});

export const Main = chakra("div", {
  base: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
  },
});

export const Footer = chakra("div", {
  base: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    width: "100%",
  },
});

// `ul` próprio em vez de `List.Root`, pelo mesmo motivo dos campos em vbaby.
export const StepList = chakra("ul", {
  base: {
    display: "flex",
    flexDirection: "column",
    gap: "13px",
    listStyle: "none",
  },
});

export const StepRow = chakra("li", {
  base: { display: "flex", alignItems: "flex-start", gap: "11px" },
});

export const StepNumber = chakra("span", {
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: "24px",
    height: "24px",
    borderRadius: "full",
    background: "vbaby.purple",
    color: "white",
    fontFamily: "numeric",
    fontSize: "12px",
    fontWeight: "700",
  },
});

export const StepText = chakra("span", {
  base: {
    fontFamily: "body",
    fontSize: "13px",
    lineHeight: "19px",
    color: "vbaby.label",
    "& > strong": { fontWeight: "700" },
  },
});

export const StoreBadge = chakra("button", {
  base: {
    display: "block",
    padding: 0,
    border: "none",
    background: "none",
    lineHeight: 0,
    cursor: "pointer",
    _focusVisible: {
      outline: "2px solid",
      outlineColor: "vbaby.accent",
      outlineOffset: "2px",
    },
    "& > img": { width: "150px", height: "auto" },
  },
});

export const QrHint = chakra("div", {
  base: {
    display: "none",
    lg: {
      display: "flex",
      alignItems: "center",
      gap: "14px",
      padding: "14px",
      borderRadius: "12px",
      background: "vbaby.lilac",
    },
  },
});

export const QrFrame = chakra("div", {
  base: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    padding: "6px",
    borderRadius: "8px",
    background: "white",
    fontFamily: "body",
    fontSize: "9px",
    fontWeight: "600",
    color: "vbaby.text2",
  },
});

export const TextButton = chakra("button", {
  base: {
    padding: "8px 12px",
    marginTop: "24px",
    border: "none",
    background: "none",
    color: VBabyColors.primaryDark,
    fontFamily: "heading",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
  },
});

export const SelectLanguageContainer = chakra("div", {
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "2px",
    width: "18rem",
    padding: "12px 24px",
    borderRadius: "4px",
    background: "white",
    color: VBabyColors.gray70,
  },
});

export const SelectLanguageButtonContainer = chakra("div", {
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "8px",
    borderRadius: "4px",
    cursor: "pointer",
  },
});

export const Divider = chakra("div", {
  base: {
    boxSizing: "border-box",
    width: "calc(100% - 48px)",
    height: "1px",
    background: VBabyColors.gray10,
    lg: { width: "50%" },
  },
});

export const PoliciesContainer = chakra("div", {
  base: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "0 12px",
    marginBottom: "24px",
    lg: { flexDirection: "row" },
  },
});
